import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header, Navbar } from './components';
import { Box } from '@mui/material';
import useLayoutStyles from './useLayoutStyles';
const Layout = ({}) => {
    const { mainContentContainerStyles } = useLayoutStyles();
    const location = useLocation();
    // List of routes where Navbar should be hidden
    const hideNavbarRoutes = ['/projects'];
    const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);
    return (_jsxs(React.Fragment, { children: [_jsx(Header, {}), !shouldHideNavbar && _jsx(Navbar, {}), _jsx(Box, { className: 'main-content-container', sx: mainContentContainerStyles, children: _jsx(Outlet, {}) })] }));
};
export default Layout;
